import {
    Box,
    Button,
    Card,
    Divider,
    List,
    ListItem,
    Typography,
} from "@mui/material";

export default function RegulationsContainer({
    displayButton = false,
    onButtonClick = () => {},
}) {
    return (
        <Box>
            <Typography
                sx={{
                    width: "100%",
                    fontSize: "0.875rem",
                    fontWeight: "bold",
                    color: "#1E7148",
                    padding: "0",
                    textAlign: {
                        xs: "center",
                        sm: "left",
                    },
                }}
            >
                شما با ثبت تعهد شرعی در جلسه ۵، این قوانین را پذیرفته‌اید
            </Typography>

            <Box height="16px" />

            <Card sx={{ padding: "20px" }}>
                <Typography sx={{ fontSize: "1.1rem", fontWeight: "bold" }}>
                    هدف از قوانین دوره
                </Typography>

                <List
                    sx={{
                        listStyleType: "disc",
                        listStylePosition: "inside",
                        left: "-16px",
                    }}
                >
                    <RegulationItem>
                        این دوره، یک دوره عملی است و برای دستیابی به نتایج مطلوب
                        در عادت‌سازی، لازم است قوانین آن را رعایت کنید.
                    </RegulationItem>

                    <RegulationItem>
                        قوانین منطبق با اصول عادت‌سازی (که در ادامه دوره مطرح
                        می‌‌شود) و همچنین سیر و سلوک معنوی (مشارطه و معاقبه)
                        هستند و هدف آن‌ها بازدارندگی از رهاکردن دوره است.
                    </RegulationItem>
                </List>

                <Box height="16px" />

                <Divider />

                <Box height="16px" />

                <Typography
                    sx={{
                        fontSize: "1.1rem",
                        fontWeight: "bold",
                    }}
                >
                    هزینه دوره و شرایط انصراف چگونه است؟
                </Typography>

                <List
                    sx={{
                        listStyleType: "disc",
                        listStylePosition: "inside",
                        left: "-16px",
                    }}
                >
                    <RegulationItem>
                        حوزه مجازی مهندس طلبه با وجود هزینه‌های بسیار زیادی که
                        متحمل می‌شود، دوره تغییر عادت را به شرط اتمام، رایگان
                        ارائه می‌دهد.
                    </RegulationItem>

                    <RegulationItem>
                        با پذیرش قوانین، لازم است دوره را حداقل تا انتهای چله
                        دوم (جلسه ۱۰۵) تکمیل کنید، بدین معنا که در این مدت هم
                        تمامی جلسات را به طور کامل مشاهده کرده و هم تکالیف
                        روزانه را به صورت منظم انجام دهید. پس از این مرحله،
                        امکان انصراف رایگان برای شما فراهم خواهد بود.
                    </RegulationItem>

                    <RegulationItem>
                        بعد از ورود به چله سوم، ملزم به تکمیل دوره تا پایان چله
                        پنجم (جلسه ۲۲۵) هستید و سپس می‌توانید رایگان انصراف
                        دهید.
                    </RegulationItem>

                    <RegulationItem>
                        اگر وارد چله ششم شوید، باید دوره را به اتمام برسانید.
                    </RegulationItem>

                    <RegulationItem>
                        در صورتی که‌
                        <Typography
                            variant="span"
                            sx={{
                                textDecoration: "underline",
                                fontWeight: "bold",
                                padding: "0 2px",
                            }}
                        >
                            به هر دلیلی‌
                        </Typography>
                        ، خارج از بازه‌های مجاز (پایان چله دوم و چله پنجم)
                        انصراف دهید، شرعا موظف هستید{" "}
                        <Typography
                            variant="span"
                            sx={{
                                textDecoration: "underline",
                                fontWeight: "bold",
                                padding: "0 2px",
                            }}
                        >
                            مبلغ ۱ میلیون تومان
                        </Typography>{" "}
                        به حوزه مجازی مهندس طلبه واریز کنید.
                    </RegulationItem>
                </List>

                <Box height="16px" />

                <Divider />

                <Box height="16px" />

                <Typography
                    sx={{
                        fontSize: "1.1rem",
                        fontWeight: "bold",
                    }}
                >
                    تا کی باید جلسات را ببینیم و آزمون دهیم؟{" "}
                </Typography>
                <List
                    sx={{
                        listStyleType: "disc",
                        listStylePosition: "inside",
                        left: "-16px",
                    }}
                >
                    <RegulationItem>
                        هر جلسه از شروع روز (۰۰:۰۰ بامداد) تا انتهای شب (۲۳:۵۹
                        شب) به مدت ۲۴ ساعت، در دسترس است.{" "}
                    </RegulationItem>

                    <RegulationItem>جلسات حدود ۱۵ دقیقه هستند.</RegulationItem>

                    <RegulationItem>
                        در صورتی که در ۲۴ ساعت، ۱۵ دقیقه زمان ندارید، می‌توانید
                        سرعت جلسه را تا ۲ برابر افزایش دهید و در حدود ۸ دقیقه
                        جلسه را مشاهده نمایید.
                    </RegulationItem>

                    <RegulationItem>
                        بعد از مشاهده جلسه، لازم است در یک آزمون ساده با ۵ سوال
                        شرکت کنید و پس از کسب حداقل نمره ۴۰ از ۱۰۰ (یعنی ۲ پاسخ
                        صحیح)،‌ جلسه بعدی در ۱۲ شب برای شما باز می‌شود.
                    </RegulationItem>

                    <RegulationItem>
                        آزمون نمره منفی ندارد. یعنی پاسخ‌های اشتباه منجر به کسر
                        نمره نخواهد شد.
                    </RegulationItem>
                    <RegulationItem>
                        شما ۲ بار فرصت شرکت در آزمون دارید.
                    </RegulationItem>
                </List>

                <Box height="16px" />

                <Divider />

                <Box height="16px" />

                <Typography sx={{ fontSize: "1.1rem", fontWeight: "bold" }}>
                    هدف جریمه چیست و چند نوع جریمه داریم؟{" "}
                </Typography>

                <List
                    sx={{
                        listStyleType: "disc",
                        listStylePosition: "inside",
                        left: "-16px",
                    }}
                >
                    <RegulationItem>
                        جریمه‌ها برای بازدارندگی هستند. در واقع باید تلاش کنید
                        که جریمه نشوید.
                    </RegulationItem>

                    <RegulationItem>
                        در دوره تغییر عادت سه نوع جریمه داریم:
                        <List
                            sx={{
                                listStyleType: "disc",
                                listStylePosition: "inside",
                                left: "-8px",
                            }}
                        >
                            <RegulationInnerItem>
                                <Typography variant="span" fontWeight="bold">
                                    عدم شرکت در آزمون:
                                </Typography>{" "}
                                زمانی که جلسه را مشاهده کنید اما تا پایان زمان
                                مجاز، آزمون را ثبت نکنید.
                            </RegulationInnerItem>

                            <RegulationInnerItem>
                                <Typography variant="span" fontWeight="bold">
                                    عدم مشاهده جلسه:
                                </Typography>{" "}
                                در صورتی که یک روز کامل غیبت داشته باشید و جلسه
                                را مشاهده نکنید.
                            </RegulationInnerItem>

                            <RegulationInnerItem>
                                <Typography variant="span" fontWeight="bold">
                                    عدم موفقیت در دو بار آزمون:
                                </Typography>{" "}
                                برای هر جلسه ۲ فرصت آزمون دارید. اگر در هر ۲
                                نوبت موفق به کسب نمره قبولی نشوید، مشمول جریمه
                                می‌شوید.
                            </RegulationInnerItem>
                        </List>
                    </RegulationItem>

                    <RegulationItem>
                        مبلغ پایه هر جریمه ۵,۰۰۰ تومان است و برای هر بار تکرار،
                        مبلغ آن ۵,۰۰۰ تومان افزایش می‌یابد و تا سقف ۵۰,۰۰۰ تومان
                        ادامه پیدا می‌کند.
                    </RegulationItem>

                    <RegulationItem>
                        افزایش جریمه برای هر نوع جریمه جداگانه حساب می‌شود.
                        <br />
                        برای مثال، ممکن است بسته به تعداد دفعات، جریمهٔ «عدم
                        مشاهده جلسه» به ۱۰,۰۰۰ تومان برسد، در حالی که به‌خاطر
                        «عدم شرکت در آزمون» مجبور شوید ۲۵,۰۰۰ تومان پرداخت کنید.
                    </RegulationItem>
                </List>

                {displayButton && (
                    <>
                        <Box height="16px" />
                        <Button
                            variant="outlined"
                            size="large"
                            sx={{ fontWeight: "bold" }}
                            fullWidth
                            onClick={onButtonClick}
                        >
                            متوجه شدم
                        </Button>
                    </>
                )}
            </Card>
        </Box>
    );
}

function RegulationItem({ children }) {
    return (
        <ListItem
            sx={{
                display: "flex",
                listStyleType: "none",
                marginLeft: "8px",
                textIndent: "8px",
                ":before": {
                    position: "absolute",
                    top: "4px",
                    content: '"•"',
                    textIndent: "-8px",
                    fontSize: "1.1rem",
                },
            }}
        >
            <Typography variant="p">{children}</Typography>
        </ListItem>
    );
}

function RegulationInnerItem({ children }) {
    return (
        <ListItem
            sx={{
                display: "flex",
                listStyleType: "none",
                marginLeft: "8px",
                textIndent: "8px",
                ":before": {
                    position: "absolute",
                    top: "6px",
                    content: '"-"',
                    textIndent: "-8px",
                    fontSize: "1.1rem",
                },
            }}
        >
            <Typography variant="p">{children}</Typography>
        </ListItem>
    );
}
